import { Link } from "react-router-dom";
import { gameCategories } from "@/mocks/homeData";

export default function GameCategories() {
  return (
    <section id="categories" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            热门游戏分类
          </h2>
          <p className="mt-3 text-foreground-600 text-base">
            多元玩法，满足您的每一种娱乐需求
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {gameCategories.map((category, index) => (
            <Link
              key={category.id}
              to={`/category/${category.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 flex items-center gap-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className={`${category.icon} text-lg`}></i>
                  </div>
                  <h3 className="text-xl font-heading font-bold text-background-50">
                    {category.name}
                  </h3>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {category.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {category.features.map((feature) => (
                    <span
                      key={feature}
                      className="px-3 py-1 text-xs rounded-full bg-accent-100 text-accent-700 font-medium"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}